import {AccessorsMutatorsDecorator, Model} from "../../helpers";
import moment from "moment";

export class Closeout extends Model {

    availability(dateFormat) {

        return moment(this.start_date).format(dateFormat) + ' - ' + moment(this.end_date).format(dateFormat);
    }

    get channel() {
        const channels = this.channels.map(channel => channel.name);

        return channels.join(', ')
    }
}

AccessorsMutatorsDecorator(
    'id',
    'start_date',
    'end_date',
    'channels',
    'property',
)(Closeout);


// WEBPACK FOOTER //
// ./src/pms-api/models/closeout.model.js